import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import QueryKeys from 'hooks/queries/keys';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import useMutation from '../useMutation';

import MutationKeys from './keys';
import { DisplayConditionListItem } from './useArchiveDisplayCondition';

/**
 * Reverses an archive on a display condition.
 * @param conditionId the id of the condition being unarchived
 * @param mutateOptions react-query useMutation option
 */
const useUnarchiveDisplayCondition = (
    conditionId: number,
    mutateOptions?: UseMutationOptions<DisplayConditionListItem, Error, void>
) => {
    const queryClient = useQueryClient();
    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<void, DisplayConditionListItem>(
        MutationKeys.UNARCHIVE_DISPLAY_CONDITION(conditionId),
        `${CuredApiPaths.ROW_DISPLAY_CONDITIONS}/${conditionId}/unarchive`,
        {
            onSuccess: async (data, variables, context) => {
                // Await so the Manage table's cache is already fresh by the time this resolves.
                await Promise.all([
                    queryClient.invalidateQueries(QueryKeys.ROW_DISPLAY_CONDITIONS),
                    queryClient.invalidateQueries(QueryKeys.DYNAMIC_CONTENT_CATEGORIES),
                    queryClient.invalidateQueries(['manage-display-conditions']),
                ]);
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.POST
    );
};

export default useUnarchiveDisplayCondition;
